import { useState, useEffect } from "react";
import { FormInstance, Image, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { UploadService } from "../../services/upload";
import { createFormData } from "../../../utilities/formData";
import { HttpStatusCode } from "axios";
import { API_BASE_URL_IMAGE } from "../../../utilities/API_CONSTANT";
import style from "./style.module.scss";
import { FaFile } from "react-icons/fa";

const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/jpg"];

export type MediaItem = {
  label: string;
  value: string;
  contentUrl: string;
  mediaType: string;
};

type Props = {
  form?: FormInstance;
  name: string;
  multipleFiles?: boolean;
};

export const DynamicUploadMediaList = ({
  form,
  name,
  multipleFiles = true,
}: Props) => {
  const [mediaList, setMediaList] = useState<MediaItem[]>(
    form?.getFieldValue(name) ?? []
  );
  const [, setLoadingIndexes] = useState<number[]>([]);

  useEffect(() => {
    form?.setFieldValue(name, mediaList);
  }, [mediaList]);

  const uploadFile = async (file: File) => {
    const index = Date.now();
    setLoadingIndexes((prev) => [...prev, index]);

    try {
      const isImage = IMAGE_TYPES.includes(file.type);
      const res = isImage
        ? await UploadService.uploadImage(createFormData({ file }))
        : await UploadService.uploadFile(createFormData({ file }));

      if (
        res?.status === HttpStatusCode.Created ||
        res?.status === HttpStatusCode.Ok
      ) {
        const mediaItem: MediaItem = {
          label: res.data.basename,
          value: res.data["@id"],
          contentUrl: res.data.contentUrl,
          mediaType: res.data.mediaType ?? (isImage ? "image" : "file"),
        };

        setMediaList((prev) =>
          multipleFiles ? [...prev, mediaItem] : [mediaItem]
        );
      }
    } catch (err) {
      message.error("Échec de l'upload du fichier.");
    } finally {
      setLoadingIndexes((prev) => prev.filter((i) => i !== index));
    }
  };

  const handleDelete = (index: number) => {
    setMediaList((prev) => prev.filter((_, i) => i !== index));
  };

  const customRequest = ({ file }: any) => {
    uploadFile(file);
  };

  return (
    <div className={style.media_list_wrapper}>
      <div className={style.media_list_content}>
        <Upload
          customRequest={customRequest}
          showUploadList={false}
          multiple={multipleFiles}
        >
          <div className={style.upload_placeholder}>
            <UploadOutlined />
            <span style={{ marginLeft: 8 }}>Upload</span>
          </div>
        </Upload>

        {mediaList.map((media, idx) => (
          <div key={idx} className={style.media_card}>
            {media.mediaType === "image" ? (
              <Image
                src={`${API_BASE_URL_IMAGE}${media.contentUrl}`}
                width={150}
                height={150}
                style={{ objectFit: "cover", borderRadius: 8 }}
                preview={true}
              />
            ) : (
              <div className={style.file_card}>
                <FaFile size={40} color="#555" />
                <span className={style.file_name}>{media.label}</span>
              </div>
            )}
            <div
              className={style.tooltip_delete}
              onClick={() => handleDelete(idx)}
            >
              Supprimer
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
